import { XMarkIcon } from "@heroicons/react/20/solid";
import { format } from "date-fns";
import { connect } from "react-redux";
import { Actions as COMPANYACTIONS } from "../../store/actions/companyActions";
import sanitize from "sanitize-html";

const BillingEmailModal = ({ modalStatus, closeModal, email }) => {
	if (!modalStatus) return null;
	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "60%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">
								{email.email} - {email.subject} - {format(new Date(email.date), "yyyy-MM-dd")}
							</h3>
						</div>
						<div
							className="block-content"
							style={{ paddingBottom: 20 }}
							dangerouslySetInnerHTML={{ __html: sanitize(email.html) }}
						></div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		modalStatus: state?.company?.billingEmailModalStatus,
		email: state?.company?.billingEmailModal,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(COMPANYACTIONS.openBillingEmailModal(null, false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BillingEmailModal);
